import {
  AloftPrice,
  expected,
  isDefined,
  orUndefined,
  schAlertType,
  schAloftPrice,
  schPairedCostRouteItem,
} from '@aloft/toolkit-shared';

import { AlertDefinition } from '../../types.ts';

export const bracketedMarketValue: AlertDefinition = ({
  compAdjustments,
  compSequence,
  order,
  reconciliation,
}) => {
  if (!order.isInspectifyOrder) return undefined;
  const compAdjustedSalePrices = compSequence
    .map((id) => compAdjustments[id]?.adjustedSalePrice.adjustment)
    .filter(isDefined);

  const opinionOfMarketValue = orUndefined(schAloftPrice.parse)(reconciliation.opinionOfMarketValue);

  if (!opinionOfMarketValue || compAdjustedSalePrices.length < 2) return undefined;

  const minAdjustedSalePrice = expected(AloftPrice.min(compAdjustedSalePrices));
  const maxAdjustedSalePrice = expected(AloftPrice.max(compAdjustedSalePrices));

  if (opinionOfMarketValue.ge(minAdjustedSalePrice) && opinionOfMarketValue.le(maxAdjustedSalePrice)) {
    return undefined;
  }

  return {
    type: schAlertType.enum.bracketedMarketValue,
    status: 'active',
    message: `Opinion of Market Value (${opinionOfMarketValue.toString()}) is not bracketed by the adjusted sales price range of comparables (${minAdjustedSalePrice.toString()} - ${maxAdjustedSalePrice.toString()})`,
    propertyID: 'subject',
    fixingInfo: {
      tips: 'Tips: Bracketing is a key appraisal practice used to demonstrate support for the final value conclusion and ensure consistency with the comparable sales analysis. Revise the Opinion of Market Value so that it is bracketed, or provide clear commentary supporting why the value falls outside of that range',
      pairedCostRouteItem: schPairedCostRouteItem.enum['adjustments-grid'],
    },
  };
};
